import React from 'react'

import { FlexByRow, XDivider, YDivider } from 'irmlib/styles'
import PageHeader from '../AppControl/PageHeader'
import { TextField, CheckBox, Select, ClearButton, SaveButton } from 'irmlib/components/FormControls'
import { useFormTemplate } from 'irmlib/hooks'

const selectItems = [
  { value: '10', label: 'demo.select1' },
  { value: '20', label: 'demo.select2' },
  { value: '30', label: 'demo.select3' },
  { value: '40', label: 'demo.select4' },
  { value: '50', label: 'demo.select5' }
]

const formTemplate = [
  {
    label: 'demo.name',
    /* Place holder, only applies to TextEdit */
    // placeholder: 'Name',
    /* If the data for a field is located at the same key in the object for both get and post,
       use this field. The format is obj.obj1.key. */
    fieldKey: 'obj.obj1.name',
    /* If the data for a field is located at different keys in the object for get and post,
       use this field for its location in the api get object. The format is obj.obj1.key. */
    // getFieldKey: 'homePhone',
    /* If the data for a field is located at different keys in the object for get and post,
       use this field for its location in the api post object. The format is obj.obj1.key. */
    // postFieldKey: 'name',
    /* default value for the field. */
    defaultValue: '', // Required at least for clear to work.
    /* The start state of the control is disabled. */
    disabled: false,
    /* Indicates that the field is required. */
    isRequired: true,
    /* Max number of characters for the field. Applies only to TextFields. */
    // maxLength: 15,
    /* The default error message for a missing required field is 'Required'. If you want something else use this. */
    // isRequiredError: '',
    /* Use a regx to validate the vield. */
    // regx: regx.alphanumericRegex,
    /* If the regx test fails, display this message. */
    // regxError: regx.alphanumericRegexError
    /* Validate the field with the function below. */
    validator: value => {
      if (value.length > 20) {
        return 'demo.validateFieldErrorMsg'
      }
      return ''
    },
    /* For number text fields, this is the maximum value.  */
    // maxValue: 10,
    /* For number text fields, this is the minimum  value.  */
    // minValue: 10,
    /* The data displayed may be different than the field in the get object. Use this for the conversion. */
    // onAfterGet: function,
    /* The data displayed may be different than the field in the post object. Use this for the conversion. */
    // onBeforePost: function
  },
  {
    label: 'demo.address',
    fieldKey: 'obj.obj1.address',
    defaultValue: '',
    isRequired: true,
    maxLength: 15,
  },
  {
    label: 'demo.selectDemo',
    fieldKey: 'obj.obj1.select',
    defaultValue: '30',
    isRequired: true,
  },
  {
    label: 'demo.checkbox',
    fieldKey: 'obj.obj1.check',
    defaultValue: false
  }
]

const VerticalDivider = () =>
  <YDivider height='20px' />

// Defined the below in services.
// Use the function uiPost for the post.
const postService = async postObject => {
  // eslint-disable-next-line no-console
  console.log(JSON.stringify(postObject, undefined, 2))
  return Promise.resolve()
}

const NAME_FIELD = 0
const ADDRESS_FIELD = 1
const SELECT_FIELD = 2
const CHECK_FIELD = 3

// This does not have an edit feature. It is for new input only and then a save.
const FormDemo = props => {
  const arrRefs = useFormTemplate(formTemplate)

  return (
    <>
      <PageHeader>
        demo.formDemo
      </PageHeader>
      <YDivider height='40px' />
      <TextField
        fieldTemplate={formTemplate[NAME_FIELD]}
        ref={arrRefs[NAME_FIELD]}
      />
      <VerticalDivider />
      <TextField
        fieldTemplate={formTemplate[ADDRESS_FIELD]}
        ref={arrRefs[ADDRESS_FIELD]}
      />
      <VerticalDivider />  
      <Select
        items={selectItems}
        fieldTemplate={formTemplate[SELECT_FIELD]}
        ref={arrRefs[SELECT_FIELD]}
      />
      <VerticalDivider />  
      <CheckBox
        fieldTemplate={formTemplate[CHECK_FIELD]}
        ref={arrRefs[CHECK_FIELD]}
      />
      <YDivider height='40px' />
      <FlexByRow>
        <ClearButton arrRefs={arrRefs} />
        <XDivider width='10px' />
        <SaveButton formTemplate={formTemplate} arrRefs={arrRefs} postService={postService} />
      </FlexByRow>
    </>
  )
}

export default FormDemo